<ion-content [color]="remoteConfigValues.ColorFondo">

  <div class="display">
    <div class="center">
  
      <ion-img [src]="remoteConfigValues.Imagen | assetsUrl" [ngStyle]="remoteConfigValues.StyleImg"></ion-img>
    
      <ion-label [innerHTML]="remoteConfigValues.Descripcion | htmlSeguro" class="ion-margin-horizontal"></ion-label>
  
    </div>
  </div>

</ion-content>
